<template>
  <div>
    <v-card>
    <v-toolbar color="primary" dark>
      <v-toolbar-title aling="center">Parametrización</v-toolbar-title>
    </v-toolbar>
    <v-tabs>
      <v-tab align-with-title="true">
        <v-icon left>mdi-elevation-rise</v-icon>
        Modelo
      </v-tab>
      <v-divider></v-divider>
      <v-tab style="align-content: flex-start;">
        <v-icon left>mdi-account-multiple</v-icon>
        Participantes
      </v-tab>

      <v-tab>
        <v-icon left>mdi-clipboard-text</v-icon>
        Kpi Objetivos
      </v-tab>
      <v-tab>
        <v-icon left>mdi-calendar</v-icon>
        Calendario
      </v-tab>
      <v-tab>
        <v-icon left>mdi-checkbox-marked</v-icon>
        Tareas
      </v-tab>
      <v-tab>
        <v-icon left>mdi-file-document-box</v-icon>
        Reporteria
      </v-tab>
      <v-tab>
        <v-icon left>mdi-history</v-icon>
        Historicos
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
              <v-container>
                  <v-row align="center">
                      <v-col cols="2">
                          Competencias:
                      </v-col>
                      <v-col cols="2">
                               <v-progress-circular
                                rotate="270"
                                size="64"
                                :value="primero"
                                width="10"
                                color="light-blue"
                                @click="modporcen('com')"
                            >{{primero}}</v-progress-circular>
                      </v-col>

                      <v-col cols="2">
                          KPI Objetivos:
                      </v-col>
                      <v-col cols="2">
                               <v-progress-circular
                                rotate="90"
                                size="64"
                                :value="segundo"
                                width="10"
                                color="red"
                                @click="modporcen('kpi')"
                            >{{segundo}}</v-progress-circular>
                      </v-col>

                      <v-col cols="3">
                          Evaluacion de Medio Año:
                      </v-col>
                      <v-col cols="1">
                          <v-switch></v-switch>
                      </v-col>                                       
                  </v-row>
                  <v-row align="center">
                      <v-col cols="3">
                          Diccionario de Competencias:
                      </v-col>                                       
                      <v-col cols="3">
                            <v-select
                            :items="['Propio','Predefinido','Mix']"
                            v-model="diccionario"
                            label="Tipo de Diccionario"
                            outlined
                          ></v-select>
                      </v-col>
                      <v-col cols="6" v-if="diccionario == 'Propio' | diccionario == 'mix'">
                           <v-file-input show-size label="Diccionario"></v-file-input>
                      </v-col>
                  </v-row>

                  <v-row align="center">
                      <v-col cols="3">
                          Objetivos:
                      </v-col>                                       
                      <v-col cols="3">
                            <v-select
                            :items="['Obj1','Obj2','Obj3']"
                            label="Tipo de Objetivos"
                            outlined
                            multiple
                          ></v-select>
                      </v-col>
                      <v-col cols="3">
                          <v-text-field
                                    value=""
                                    label="Porcentaje"
                                    outlined
                                    type="number"
                                ></v-text-field>
                      </v-col>                       
                      <v-col cols="3">
                           Participantes Afectados
                      </v-col>
                  </v-row>
              </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              :headers="headers"
              :items="desserts"
              :items-per-page="5"
              class="elevation-1"
              :search="search"
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
           
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
           <v-row align="center">
                      <v-col cols="12">
                          Calendario:
                          <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="date"
                                label="Date"
                                
                                persistent-hint
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                          </v-menu>
                        
                      </v-col>                                       
                  </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>


    </v-tabs>
  </v-card>

<v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">0 al 100</v-card-title>
        <v-card-text>
          <v-slider v-if="dialogoType=='com'"
          v-model="primero" color="light-blue"
          thumb-label="always"
          ></v-slider>
          <v-slider v-else
          v-model="segundo" color="red"
          thumb-label="always"
          ></v-slider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
export default {
  name: 'parametrizacion',
  data:()=>({
    slider:100,
    primero:50,
    segundo:50,
    dialog: false,
    dialogoType:'',
    diccionario:'',
    search: '',
    headers: [
          {
            text: 'Participante',
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: 'Fecha Ingreso', value: 'calories' },
          { text: 'Area', value: 'fat' },
          { text: 'Departamento', value: 'carbs' },
          { text: 'Cargo', value: 'protein' },
          { text: 'Evaluado', value: 'iron' },
        ],
        desserts: [
          {
            name: 'Jose Valdivia',
            calories: '01/02/2020',
            fat: 'Talento',
            carbs: 'Finanzas',
            protein: 'Jefe Area',
            iron: 'no',
          },
          {
            name: 'Alexander Padron',
            calories: '02/02/2020',
            fat: 'Talento',
            carbs: 'Informatica',
            protein: 'Jefe Area',
            iron: 'no',
          },
          {
            name: 'Ejemplo 002',
            calories: '04/03/2020',
            fat: 'Talento',
            carbs: 'Finanzas',
            protein: 'Jefe Area',
            iron: 'no',
          },          
        ],    
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: new Date().toISOString().substr(0, 10),
    menu1: false

  }),
  watch: {
    primero(valor){
      this.segundo = this.slider - valor;
    },
    segundo(valor){
      this.primero = this.slider - valor;
    }
  },
  
  computed: {
    computedDateFormatted () {
        return this.formatDate(this.date)
      },
  },
  methods: {
      modporcen(evento){
        if(evento=='com'){
          this.dialogoType='com';
        }else{
          this.dialogoType='kpi';
        }
        this.dialog = true;
      },
      formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
  
}
</script>